/**
 * Clinio Design system V2 tokens (Designmanual V2, 20 Oct 2026).
 * CSS variables live in `src/styles/design-v2.css`. Tailwind maps them as `ds-*`.
 */

export const DS_COLOR = {
  bg: '#FAF7F2',
  side: '#F4F0E9',
  card: '#FFFFFF',
  sunk: '#F7F4EF',
  'neutral-tint': '#F1EDE6',
  teal: '#0F5C5C',
  'teal-700': '#0B4747',
  'teal-tint': '#E3F0EE',
  'teal-line': '#BFDCD7',
  coral: '#E0705A',
  'coral-tint': '#FCE9E4',
  'coral-ink': '#A3412D',
  'coral-badge': '#B44C37',
  amber: '#B7791F',
  'amber-tint': '#FBF1DF',
  'amber-ink': '#8C5D14',
  green: '#3F8F5A',
  'green-tint': '#E7F2EA',
  'green-ink': '#2E6E44',
  red: '#C2412D',
  'red-tint': '#FBEAE6',
  'red-ink': '#AE3A27',
  text: '#1E2A2A',
  muted: '#5E6B6B',
  placeholder: '#6B7676',
  field: '#968E83',
  line: '#E8E4DD',
  disabled: '#EFEBE4',
  'disabled-bg': '#EFEBE4',
  'disabled-border': '#E3DED6',
  'disabled-line': '#E3DED6',
  'disabled-ink': '#A8AEAE',
  'danger-hover': '#8F2F1F',
  'danger-700': '#8F2F1F',
  toast: '#1E2A2A',
  'toast-bg': '#1E2A2A',
  'toast-ink': '#FFFFFF',
  'toast-link': '#9FE0D6',
  'cancelled-rail': '#D6D0C6',
  'line-strong': '#D6D0C6',
  'skeleton-from': '#EFEAE2',
  'skeleton-to': '#F7F3ED',
  'sk-1': '#EFEAE2',
  'sk-2': '#F7F3ED',
  'on-accent': '#FFFFFF',
  'text-2': '#2A3636',
  'row-hover': '#FDFCFA',
  toolbar: '#FCFBF8',
  'switch-off': '#968E83',
  'toggle-off': '#D6D0C6',
  knob: '#FFFFFF',
} as const;

export const DS_SCRIM = 'rgba(30, 42, 42, 0.32)';

export const DS_SPACING = {
  s1: 4,
  s2: 8,
  s3: 12,
  s4: 16,
  s5: 24,
  s6: 32,
  s7: 48,
} as const;

export const DS_RADIUS = {
  ctl: 10,
  card: 16,
  pop: 12,
  pill: 999,
} as const;

export const DS_SIZE = {
  navWidth: 248,
  navCollapsedWidth: 64,
  control: 40,
  controlSm: 32,
  chip: 24,
  filterChip: 32,
  tab: 44,
  slideOver: 560,
  slideOverWide: 720,
  modalMax: 480,
  searchMax: 420,
  toastMax: 420,
  emptyIcon: 64,
  avatarList: 36,
  avatarThread: 40,
  avatarRelation: 48,
  avatarPatient: 72,
  avatarPatientMobile: 56,
} as const;

export const DS_BREAKPOINT_NAV = 760;

export const DS_TOAST_MS = 6000;

export const DS_SHADOW = {
  card: '0 1px 2px rgba(0,0,0,.04), 0 4px 16px rgba(0,0,0,.04)',
  pop: '0 2px 4px rgba(30,42,42,.06), 0 12px 32px rgba(30,42,42,.12)',
} as const;

export type DsColorName = keyof typeof DS_COLOR;

export function dsVar(name: DsColorName | 'scrim'): string {
  return name === 'scrim' ? 'var(--scrim)' : `var(--${name})`;
}
